'use client'

import { cn } from '@qr-front/ui/utils'
import { useEffect, useState } from 'react'

import { isOnServer } from '@/utils'

import { TQrContent } from '../../generatorTypes'
import { createQrImageBuilder, TQrDesign } from '../../services/client'
import { getQrDataToEncode } from '../../utils/buildQrLandingUrl'

export const QrImageWrapper = ({
	qrUri,
	qrContent,
	qrDesign,
}: {
	qrUri: string
	qrContent: TQrContent
	qrDesign: TQrDesign
}) => {
	const [qrSvg, setQrSvg] = useState('')

	useEffect(() => {
		if (!isOnServer && !qrSvg) {
			const dataToEncode = getQrDataToEncode({ qrUri, qrContent })
			createQrImageBuilder({ ...qrDesign, data: dataToEncode })
				.then((qrImageBuilder) => qrImageBuilder.getSvg())
				.then(setQrSvg)
		}
	}, [qrContent, qrDesign, qrSvg, qrUri])

	const isDefaultFrame = qrDesign.frame.type === 'default'

	return (
		<div
			dangerouslySetInnerHTML={{ __html: qrSvg }}
			className={cn(
				isDefaultFrame
					? 'mb-4 size-[350px] overflow-hidden rounded-16 drop-shadow-generator tablet:size-[280px]'
					: 'min-h-[460px] w-[350px] tablet:min-h-[360px] tablet:w-[280px]',
			)}
		/>
	)
}
